/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import { withTranslation, Trans } from "react-i18next";
import Input from "../inputpm";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import FormGroup from "@mui/material/FormGroup";
import { Button, IconButton, Select } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { Icon } from "@mui/material";
import { AddDocumentsIcon, DeleteIconNew } from "../icons/icons";
import pdfIcon from "../../asset/images/pdf.png";
import jpgIcon from "../../asset/images/jpg.png";
import pngIcon from "../../asset/images/png.png";
import placeholderImage from "../../asset/images/image_placeholder.png";
import { Tooltip, Switch } from "@mui/material";
import actionTypes from "../../store/actions";
import { connect } from "react-redux";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Card,
} from "@mui/material";

const GenericBPMNForm = (props) => {
  const selectBoxStyle = {
    label: {
      backgroundColor: "#fff",
      padding: "0 5px",
    },
  };
  const date = new Date();
  const today = date.toISOString().split("T")[0];
  const minDate = props.minDate ? props.minDate.split("T")[0] : today;

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");

  const formattedLocal = `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  const todayWithTime = formattedLocal;

  const sixMonthsBack = new Date(date.setMonth(date.getMonth() - 6));

  const yyyyBack = sixMonthsBack.getFullYear();
  const mmBack = String(sixMonthsBack.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const ddBack = String(sixMonthsBack.getDate()).padStart(2, "0");
  const hhBack = String(sixMonthsBack.getHours()).padStart(2, "0");
  const minBack = String(sixMonthsBack.getMinutes()).padStart(2, "0");

  const formattedBackDate = `${yyyyBack}-${mmBack}-${ddBack}T${hhBack}:${minBack}`;
  const sixMonthsBackDateValidation = formattedBackDate;

  return (
    <>
      {(() => {
        switch (props.input.type) {
          case "text":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                placeholder={props.input.name}
                id={props.input.id}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                }}
              />
            );
          case "multi-line-text":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  multiline: true,
                  maxRows: 4,
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "integer":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "number",
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "decimal":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "number",
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "date":
            return (props.actionStatus &&
              (props.actionStatus === "Confirm Installation" ||
                props.actionStatus === "CONFIRM_INSTALLATION")) ||
              (props.subItemAction &&
                (props.subItemAction === "Confirm Installation" ||
                  props.subItemAction === "CONFIRM_INSTALLATION")) ? (
              <>
                <Input
                  name={props.input.id}
                  value={props.input.value}
                  onChange={(event) => props.onChange(event)}
                  inputProps={{
                    readOnly: props.input.readOnly,
                    required: props.input.required,
                    type: "datetime-local",
                    // type: "date",
                    InputLabelProps: {
                      shrink: true,
                    },
                    min: sixMonthsBackDateValidation,
                    max: todayWithTime,
                    // defaultValue: todayWithTime
                  }}
                  placeholder={props.input.name}
                  id={props.input.id}
                />
                <label
                  style={{ marginTop: 6, float: "left", color: "#f44336" }}
                >
                  {props.t("PAST_ACTIVATION_DATE_MSG")}
                </label>
              </>
            ) : props.actionStatus &&
              props.actionStatus === "VERIFY_ODR_PAYMENT" ? (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "date",
                  InputLabelProps: {
                    shrink: true,
                  },
                  min: minDate,
                  max: today,
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            ) : (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "date",
                  InputLabelProps: {
                    shrink: true,
                  },
                  min: today,
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "password":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "password",
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "dropdown":
            return (
              <FormControl
                variant="outlined"
                size={"small"}
                className={"bpmnCustomeSelectLabel"}
              >
                <InputLabel id={props.input.id}>{props.input.name}</InputLabel>
                <Select
                  native
                  value={props.input.value}
                  name={props.input.id}
                  labelId={props.input.id}
                  onChange={(event) => props.onChange(event)}
                  inputProps={{
                    readOnly: props.input.readOnly,
                    required: props.input.required,
                  }}
                >
                  {props.input.hasEmptyValue && <option value=""></option>}
                  {props.input.options &&
                    props.input.options.length > 0 &&
                    props.input.options.map((option, index) => (
                      <option key={index} value={option.name}>
                        {option.name}
                      </option>
                    ))}
                </Select>
              </FormControl>
            );
          case "upload":
            return (
              // <Input
              //     name={props.input.id}
              //     value={props.input.value}
              //     onChange={event => props.onChange(event)}
              //     inputProps={{
              //         readOnly: props.input.readOnly,
              //         required: props.input.required,
              //         type: 'file'
              //     }}
              //     placeholder={props.input.name}
              //     id={props.input.id}
              // />
              <>
                <div>
                  <Input
                    inputProps={{
                      id: props.input.id,
                      required: props.input.required,
                      multiple:
                        props.input.params && props.input.params.multiple
                          ? props.input.params.multiple
                          : false,
                      ref: props.fileInputRef,
                    }}
                    key={`file-input-${props.uploadedFilesData?.length || 0}`}
                    name={props.input.id}
                    type="file"
                    className="custom-file-input"
                    // onChange={event => { onImageChange(event, "productMainImageSource"); resetErrroInput('productMainImage') }}
                    onChange={(event) => props.onChange(event)}
                    // value={props.input.value}
                    placeholder={props.input.name}
                  // source={this.state.productMainImageSource}
                  />
                  <label
                    htmlFor={props.input.id}
                    className={"input-file-label input-file-placeholder"}
                    style={{ display: "none" }}
                  >
                    <Icon>attach_file</Icon>
                    <label>
                      {props.input.fileName
                        ? props.input.fileName +
                        (props.input.fileLength && props.input.fileLength > 1
                          ? " (+" + (props.input.fileLength - 1) + ")"
                          : "")
                        : props.input.name +
                        (props.input.required ? " *" : "") +
                        " " +
                        props.t("PDF_IMAGES_ONLY")}
                      {/* {this.state.productMainImage ? this.state.productMainImage : <span className="input-file-placeholder">{t('PRODUCT_MAIN_IMAGE')} *</span>} */}
                    </label>
                  </label>
                  {/* {props.uploadedFilesData && props.uploadedFilesData.length > 0 && props.uploadedFilesData.map((item, index) => {
                                        return (
                                            <div style={{
                                                width: '100px', marginRight: '8px', marginLeft: '8px',
                                                marginBottom: '10px', marginTop: '0', float: 'left',
                                                textAlign: 'center', wordWrap: 'break-word',
                                                position: 'relative'
                                            }} key={index}>
                                                <img src={item.uploadedFileMimeType === "application/pdf" ? pdfIcon
                                                    : (item.uploadedFileMimeType === "image/jpeg" || item.uploadedFileMimeType === "image/jpg") ? jpgIcon
                                                        : item.uploadedFileMimeType === "image/png" ? pngIcon
                                                            : placeholderImage}
                                                    // style={{ width: '100%', cursor: 'pointer' }}
                                                    style={{ width: '80px', height: '80px', objectFit: 'contain' }}
                                                />
                                                <Tooltip title={item.uploadedFileName}>
                                                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                                                        {item.uploadedFileName}
                                                    </div>
                                                </Tooltip>
                                                <span style={{ cursor: 'pointer', position: 'absolute', top: '-5px', right: '5px' }} onClick={() => props.removeUploadedFile(index)}>
                                                    <DeleteIconNew />
                                                </span>
                                                <div>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                color="primary"
                                                                // checked={this.state.assessmentData.isPublic === 'Y' || this.props.providerType !== 'SALES_CHNL_PROVIDER'}
                                                                checked={item.isPublic}
                                                                name="isPublic"
                                                                onChange={(e) => {
                                                                    props.changeIsPublic(index)
                                                                }}
                                                                disabled={props.providerType !== 'SALES_CHNL_PROVIDER'}
                                                            />
                                                        }
                                                        style={{
                                                            fontSize: '0.875rem',
                                                            color: 'rgba(0, 0, 0, 0.54)',
                                                            marginLeft: 0
                                                        }}
                                                        label={props.t('MAKE_PUBLIC')}
                                                        labelPlacement='start'
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                    )} */}
                  {props.input.params && props.input.params.multiple ? (
                    ""
                  ) : (
                    <Tooltip title={props.t("ADD_DOCUMENTS")}>
                      {/* <AddDocumentsIcon /> */}
                      <label
                        htmlFor={props.input.id}
                        className="custom-file-button"
                        style={{
                          padding: "8px 16px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: "pointer",
                          float: "left",
                        }}
                      >
                        <Icon>attach_file</Icon>
                        <span style={{ marginLeft: "8px" }}>
                          {props.t("UPLOAD_FILE")}
                        </span>
                      </label>
                    </Tooltip>
                  )}
                  <div style={{ clear: "both" }}></div>
                </div>
                <div
                  style={{
                    display: "block",
                    clear: "both",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {props.input.params && props.input.params.multiple && (
                    <Tooltip title={props.t("ADD_DOCUMENTS")}>
                      {/* <AddDocumentsIcon /> */}
                      <label
                        htmlFor={props.input.id}
                        className="custom-file-button"
                        style={{
                          padding: "8px 16px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: "pointer",
                          float: "left",
                        }}
                      >
                        <Icon>attach_file</Icon>
                        <span style={{ marginLeft: "8px" }}>
                          {props.t("UPLOAD_FILE")}
                        </span>
                      </label>
                    </Tooltip>
                  )}
                  {props.input.params && props.input.params.multiple ? (
                    <label
                      style={{ marginTop: 6, float: "left", marginLeft: 10 }}
                    >
                      {props.t("MAX_FILE_SIZE_5MB")}.{" "}
                      {props.t("PDF_IMAGES_ONLY")}.
                    </label>
                  ) : (
                    <label>
                      {props.t("MAX_FILE_SIZE_5MB")}.{" "}
                      {props.t("PDF_IMAGES_ONLY")}.
                    </label>
                  )}
                </div>
                {props.uploadedFilesData &&
                  props.uploadedFilesData.length > 0 && (
                    <div style={{ marginTop: "16px", width: "100%" }}>
                      <Card
                        variant="outlined"
                        style={{ borderRadius: "8px", marginTop: "1rem" }}
                      >
                        <TableContainer>
                          <Table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                            className="newGlobalTable"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  style={{
                                    padding: "12px 16px",
                                    textAlign: "left",
                                  }}
                                >
                                  {props.t("FILE_NAME")}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "12px 16px",
                                    textAlign: "left",
                                  }}
                                >
                                  {props.t("FILE_TYPE")}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "12px 16px",
                                    textAlign: "center",
                                  }}
                                >
                                  {props.t("MAKE_PUBLIC")}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "12px 16px",
                                    width: "60px",
                                  }}
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {props.uploadedFilesData.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell style={{ padding: "12px 16px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={
                                          item.uploadedFileMimeType ===
                                            "application/pdf"
                                            ? pdfIcon
                                            : item.uploadedFileMimeType ===
                                              "image/jpeg" ||
                                              item.uploadedFileMimeType ===
                                              "image/jpg"
                                              ? jpgIcon
                                              : item.uploadedFileMimeType ===
                                                "image/png"
                                                ? pngIcon
                                                : placeholderImage
                                        }
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          marginRight: "8px",
                                        }}
                                      />
                                      <Tooltip title={item.uploadedFileName}>
                                        <div style={{}}>
                                          {item.uploadedFileName}
                                        </div>
                                      </Tooltip>
                                    </div>
                                  </TableCell>
                                  <TableCell style={{ padding: "12px 16px" }}>
                                    {item.uploadedFileMimeType
                                      .split("/")[1]
                                      .toUpperCase()}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color="primary"
                                          checked={
                                            item.isPublic ||
                                            props.providerType !==
                                            "SALES_CHNL_PROVIDER"
                                          }
                                          name="isPublic"
                                          onChange={() =>
                                            props.changeIsPublic(index)
                                          }
                                          disabled={
                                            props.providerType !==
                                            "SALES_CHNL_PROVIDER"
                                          }
                                        />
                                      }
                                      style={{ margin: 0 }}
                                      label=""
                                    />
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <IconButton
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        props.removeUploadedFile(index)
                                      }
                                      className="buttonSecondary"
                                    >
                                      <DeleteIconNew />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </div>
                  )}
              </>
            );
          case "expression":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                placeholder={props.input.name}
                id={props.input.id}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  helperText: props.input.expression,
                }}
              />
            );
          case "hyperlink":
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                  type: "url",
                }}
                placeholder={props.input.name}
                id={props.input.id}
              />
            );
          case "boolean":
            return (
              <FormControlLabel
                className={'no-astrik-input-field'}
                control={
                  <Checkbox
                    checked={props.input.value}
                    onChange={(event) => props.onChange(event)}
                    name={props.input.id}
                    readOnly={props.input.readOnly}
                    required={props.input.required}
                    value={props.input.value}
                    style={{ marginRight: "2px" }}
                  />
                }
                label={props.input.name}
                style={{ marginLeft: 0 }}
              />
            );
          case "radio-buttons":
            return (
              <FormControl component="fieldset" className="bpmnRadioGroup no-astrik-input-field">
                <FormLabel component="legend">{props.input.name}</FormLabel>
                <RadioGroup
                  row
                  aria-label={props.input.name}
                  name={props.input.id}
                  value={props.input.value}
                  onChange={(event) => props.onChange(event)}
                >
                  {props.input.options &&
                    props.input.options.length > 0 &&
                    props.input.options.map((option, index) => (
                      <FormControlLabel
                        value={option.name}
                        control={<Radio />}
                        label={option.name}
                        required={props.input.required}
                        readOnly={props.input.readOnly}
                        key={index}
                        style={{ marginLeft: 0 }}
                      />
                    ))}
                </RadioGroup>
              </FormControl>
            );
          case "hidden":
            return null;
          default:
            return (
              <Input
                name={props.input.id}
                value={props.input.value}
                onChange={(event) => props.onChange(event)}
                placeholder={props.input.name}
                id={props.input.id}
                inputProps={{
                  readOnly: props.input.readOnly,
                  required: props.input.required,
                }}
              />
            );
        }
      })()}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(GenericBPMNForm));
